import { __decorate } from "tslib";
import { AutoEncoder, EnumDecoder, field, IntegerDecoder } from '@simonbackx/simple-encoding';
export var ResolutionFit;
(function (ResolutionFit) {
    ResolutionFit["Contain"] = "contain";
    ResolutionFit["Cover"] = "cover";
    ResolutionFit["Fill"] = "fill";
    ResolutionFit["Inside"] = "inside";
    ResolutionFit["Outside"] = "outside";
})(ResolutionFit || (ResolutionFit = {}));
export class ResolutionRequest extends AutoEncoder {
    constructor() {
        super(...arguments);
        this.width = null;
        this.height = null;
        this.fit = ResolutionFit.Inside;
    }
}
__decorate([
    field({ decoder: IntegerDecoder, nullable: true })
], ResolutionRequest.prototype, "width", void 0);
__decorate([
    field({ decoder: IntegerDecoder, nullable: true })
], ResolutionRequest.prototype, "height", void 0);
__decorate([
    field({ decoder: new EnumDecoder(ResolutionFit) })
], ResolutionRequest.prototype, "fit", void 0);
//# sourceMappingURL=ResolutionRequest.js.map